import { compose, lifecycle, pure } from 'recompose'
import {
  pathOr,
  pipe,
  cond,
  isEmpty,
  isNil,
  is,
  identity,
  T,
  trim,
  or,
  test,
} from 'ramda'

export const document = pathOr({}, ['document'], window)

/**
 * Returns a component that will set the page title.
 * Using componentDidUpdate ensures that if `title` is
 * a function, it will get called when props updates.
 * Useful for dynamic titles. I'm using pure here because
 * I want to limit how many times this component re-renders
 *
 * @param {string|function} title Custom text to prefix the page title with.
 */
export default title =>
  compose(
    pure,
    lifecycle({
      componentDidMount() {
        setTitle(title, this.props)
      },
      componentDidUpdate() {
        setTitle(title, this.props)
      },
    }),
  )

export function setTitle(title, props) {
  let parsedTitle = pipe(
    cond([
      // if title is falsy, use empty string
      [isEmpty, () => ''],
      [isNil, () => ''],
      // if title is a string, use it as is
      [is(String), identity],
      // if title is fn, call fn with props
      [is(Function), fn => fn(props) || ''],
    ]),
    cond([
      // if title has letters, use it as is
      [test(/[\w]+/), identity],
      // otherwise return empty string
      [T, () => ''],
    ]),
    trim,
  )(title)

  const customTitle = []
  if (!or(isNil(parsedTitle), isEmpty(parsedTitle))) {
    customTitle.push(`${parsedTitle} |`)
  }
  customTitle.push('Sidecar Health')

  document.title = customTitle.join(' ')
}



// WEBPACK FOOTER //
// ./src/sidecar-utils/lib/enhancers/withPageTitle.js